<app-page-container  class="event-reg-report" [DataTableSchema]="dataTableSchema" [title]="title" 
 [dynamicFormArray]="filterSchema" [props]="props">
</app-page-container>